import React, { memo } from 'react';
import { Grid, Radio } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { IImage } from '../../../../../../common/model/ICarDetails';
import sliderDotsStyles from './sliderDotsStyles';
import clsx from 'clsx';

export interface ISliderDots {
  items: IImage[];
  makeSelection: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  currentSelection: number;
  areDotsDisabled: boolean;
  isInteriorImageDisplay: boolean;
}

const SliderDots: FunctionComponent<ISliderDots> = memo(
  ({ items, makeSelection, currentSelection, areDotsDisabled, isInteriorImageDisplay }) => {
    const style = sliderDotsStyles();

    return (
      <Grid
        container={true}
        justifyContent="center"
        className={clsx(style.container, { [style.interiorImageContainer]: isInteriorImageDisplay })}
      >
        {items?.length > 1
          ? items?.map((_item, index: number) => {
              return (
                <Radio
                  data-test="slider:dots:slider_dot"
                  key={index}
                  disabled={areDotsDisabled}
                  onClick={makeSelection}
                  value={index}
                  checked={index === currentSelection}
                  className={clsx([
                    style.sliderDots,
                    { [style.disabledDots]: areDotsDisabled },
                    { [style.selectedDot]: index === currentSelection },
                    { [style.interiorSelectedDot]: index === currentSelection && isInteriorImageDisplay },
                  ])}
                  name="sliderDots"
                  inputProps={{
                    'aria-label': `${index}`,
                  }}
                />
              );
            })
          : null}
      </Grid>
    );
  },
);

export default SliderDots;
